import React, { useEffect, useState } from 'react';
import { STO_PLAYER_ID, STO_ROOM_ID } from '../constants/commonConstants';
import { customStorage } from '../services/CommonService';

const Test = () => {
  const [roomId, setRoomId] = useState("");
  const [playerId, setPlayerId] = useState("");
  useEffect(() => {
    const rmId = customStorage.getItem(STO_ROOM_ID);
    const plId = customStorage.getItem(STO_PLAYER_ID);
    setRoomId(rmId);
    setPlayerId(plId);
  }, []);

 
  

  return (
    <div className="app-page test-page">
      <div className="test-page-card">
        <div><span>Room ID</span><strong>{roomId}</strong></div>
        <div><span>Player ID</span><strong>{playerId}</strong></div>
      </div>
    </div>
  );
};

export default Test;

